
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getNews } from '../api';
const baseUrl = '20220408CBHXJ';
Vue.use(List);
@Component({
  components: {
    NewsItem,
    BottomTabbar,
  },
})
export default class News extends Vue {
  tabs: any[] = [
    {
      title: '报名通道',
      path: `/${baseUrl}/save`,
      id: 1,
    },
    {
      title: '爆款产品',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
    {
      title: '活动信息',
      path: `/${baseUrl}/news`,
      id: 3,
    },
  ];
  activeTab = 2;
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    getNews(this.page, '全部', '9218').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data.data[0].list];
    }
    this.loading = false;
  }
}
